import styled from 'styled-components/macro';

export const StyledDetailsList = styled.ul`
    height: 100%;
    flex-direction: column;
    display: flex;
    justify-content: space-between;
    padding: 2rem 0;
`;
